import React from "react";

const KebabIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.5 5.625C10.5 5.32833 10.588 5.03832 10.7528 4.79165C10.9176 4.54497 11.1519 4.35271 11.426 4.23918C11.7001 4.12565 12.0017 4.09594 12.2926 4.15382C12.5836 4.2117 12.8509 4.35456 13.0607 4.56434C13.2704 4.77412 13.4133 5.04139 13.4712 5.33237C13.5291 5.62334 13.4994 5.92494 13.3858 6.19903C13.2723 6.47311 13.08 6.70738 12.8334 6.87221C12.5867 7.03703 12.2967 7.125 12 7.125C11.6022 7.125 11.2206 6.96697 10.9393 6.68566C10.658 6.40436 10.5 6.02283 10.5 5.625ZM12 10.5C11.7033 10.5 11.4133 10.588 11.1666 10.7528C10.92 10.9176 10.7277 11.1519 10.6142 11.426C10.5006 11.7001 10.4709 12.0017 10.5288 12.2926C10.5867 12.5836 10.7296 12.8509 10.9393 13.0607C11.1491 13.2704 11.4164 13.4133 11.7074 13.4712C11.9983 13.5291 12.2999 13.4994 12.574 13.3858C12.8481 13.2723 13.0824 13.08 13.2472 12.8334C13.412 12.5867 13.5 12.2967 13.5 12C13.5 11.6022 13.342 11.2206 13.0607 10.9393C12.7794 10.658 12.3978 10.5 12 10.5ZM12 16.875C11.7033 16.875 11.4133 16.963 11.1666 17.1278C10.92 17.2926 10.7277 17.5269 10.6142 17.801C10.5006 18.0751 10.4709 18.3767 10.5288 18.6676C10.5867 18.9586 10.7296 19.2259 10.9393 19.4357C11.1491 19.6454 11.4164 19.7883 11.7074 19.8462C11.9983 19.9041 12.2999 19.8744 12.574 19.7608C12.8481 19.6473 13.0824 19.455 13.2472 19.2084C13.412 18.9617 13.5 18.6717 13.5 18.375C13.5 17.9772 13.342 17.5956 13.0607 17.3143C12.7794 17.033 12.3978 16.875 12 16.875Z"
        fill="#3A383F"
      />
    </svg>
  );
};

export default KebabIcon;
